import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import GeneralContext from '../context/GeneralContext/GeneralContext';
import EUserTypes from '../enums/EUserTypes';

/**
 * Redirect inicial baseado no papel do usuário logado.
 * - Admin → /batches (painel administrativo)
 * - Operador / Operador-comprador → /home (PWA mobile-first com 4 botões)
 */
const HomeRedirect = () => {
  const { loggedUser } = useContext(GeneralContext);

  const isAdmin = loggedUser?.type === EUserTypes.PANEL_ADMIN.code;
  const target = isAdmin ? '/batches' : '/home';

  return <Navigate to={target} replace />;
};

export default HomeRedirect;
